import _ from 'lodash'

export default {
	data() {
		return {
			
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		
	},
	computed:{
		getTotalParcelleListesFavoris(){
			return this.$store.state.parcelle.parcelles_lists.length
		},
	},
	components:{
		
	}
}